<template lang="pug">
.custom-area-filter
  .text-small {{ title }}

  .d-flex.mt-1
    CustomInputSelectJson(
      :value='value'
      @input='$emit(`input`, $event)'
      :options='userAreas'
      :disabled='isLoading'
      style='min-width: 100px'
    )
</template>

<script>
export default {
  props: {
    title: {
      default: 'เลือกดูตามเขต',
    },
    value: {},
  },
  data: () => ({
    isLoading: false,
    userAreas: [],
  }),
  mounted() {
    this.loadUserAreas();
  },
  methods: {
    async loadUserAreas() {
      this.isLoading = true;

      try {
        const res = await this.$api.admin.permissions.getUserAreas(true);
        this.userAreas = res.data;
      } catch (e) {
        console.log(JSON.stringify(e));
      }

      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss">
// .custom-area-filter {}
</style>
